import * as React from 'react';
import { ErroHttp } from '@/lib/api';
import { abrirPapelNoEdge } from '@/lib/imprimirPapel';

/** O botão de imprimir A4 pelo Edge: o estado de "abrindo" e o erro, se houver. */
export function useAbrirNoEdge(): {
  abrir: (opcoes: Parameters<typeof abrirPapelNoEdge>[0]) => Promise<void>;
  abrindo: boolean;
  erro: string | null;
} {
  const [abrindo, definirAbrindo] = React.useState(false);
  const [erro, definirErro] = React.useState<string | null>(null);

  const abrir = React.useCallback(async (opcoes: Parameters<typeof abrirPapelNoEdge>[0]) => {
    definirErro(null);
    definirAbrindo(true);
    try {
      await abrirPapelNoEdge(opcoes);
    } catch (e) {
      definirErro(e instanceof ErroHttp ? e.message : 'Não foi possível abrir o papel no Edge.');
    } finally {
      definirAbrindo(false);
    }
  }, []);

  return { abrir, abrindo, erro };
}
